<template>
    <div class="context">
        <keep-alive include="tableView">

            <component :is="componentId"
                :showTable="showTable"
                    @changeTopTab="switchModule"
                    :ref="componentId"></component>
        </keep-alive>
    </div>
</template>

<script>
    import {mapState} from "vuex"
    import tableView from "./tableView"
    import auditView from "./auditView"
    import auditTwoView from "./auditTwoView"

    export default {
        name: "",
        components: {
            tableView,
            auditView,
            auditTwoView,
        },
        data() {
            return {
                componentId: 'tableView',
                showTable: true,
            }
        },
        methods: {
            switchModule(id) {
                this.componentId = id
                if(id == 'tableView'){
                    this.showTable = false;
                    this.$nextTick(() =>{
                        this.showTable = true;
                    })
                    this.$eventBus.$emit("pollPort")
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>